import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Typography, Hidden, Grid, Box, CssBaseline } from "@mui/material";
import { ButtonAcaoGrande } from "../../components";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import useStyles from "./styles";
import ButtonVoltar from "../../components/Botoes/ButtonVoltar";
import Titulo from "../../components/Textos/Titulo";
import Subtitulo from "../../components/Textos/Subtitulo";
// import Logo from "../../assets/images/logo.png";
import useAlert from "../../hooks/useAlert";
import {
  CampoEmail,
  BoxFinalizacao,
  Rodape,
  LogoEmpresa,
  EspacoConteudoLateralDireito,
} from "../../components";
import api from "../../api";
import { configurationVariables } from "../../environment";
import { sendDataToAPI } from "../../util/encryptApi";

export default function RecuperarSenha() {
  const [isFinalizacao, setIsFinalizacao] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const { showAlertError } = useAlert();
  const idHotsite = parseInt(configurationVariables.IdHotsite);

  const handlerChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    const response = await sendDataToAPI(
      `/Cadastro/v2/SolicitarNovaSenha?idHotsite=${idHotsite}`,
      {
        email: email,
      }
    );

    if (
      response &&
      response.data.errorMessage &&
      response.data.errorMessage.length > 0
    ) {
      if (response.data.errorMessage === "Usuário inválido.") {
        showAlertError(response.data.errorMessage);
        setIsFinalizacao(false);
      }
    } else {
      setIsFinalizacao(true);
      setEmail("");
    }
    setLoading(false);

  };

  const handlerBack = () => {
    navigate("/Login");
  };

  return (
    <>
      <CssBaseline />

      <Grid
        container
        component="main"
        sx={{ height: "100vh", justifyContent: "center" }}
      >
        <Hidden smDown></Hidden>
        {/* MENU DIREITO */}
        <EspacoConteudoLateralDireito style={{ margin: "auto" }}>
          {isFinalizacao ? (
            <Grid
              item
              xs={6}
              alignItems="center"
              justifyContent="center"
              sx={{ margin: "auto" }}
            >
              <Box>
                <BoxFinalizacao
                  icon={
                    <MarkEmailReadIcon
                      color="primary"
                      sx={{ mb: 3, fontSize: "45px", opacity: 0.5 }}
                    />
                  }
                  titulo="Confirmação de troca de senha"
                  message="Verifique em sua caixa de e-mail o link para atualização da senha!"
                  handleBack={handlerBack}
                />
              </Box>
            </Grid>
          ) : (
            <>

              <Hidden>

                <Grid
                  item
                  xs={12}
                  alignItems="center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "20px",
                  }}
                  justifyContent="center"
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                      backgroundColor: "none",
                      alignItems: "center",
                    }}
                  >
                    <LogoEmpresa idHotsite={0} />
                  </Box>
                </Grid>

              </Hidden>
              <Grid item style={{ margin: "auto" }} xs={12}>
                <Grid item style={{ margin: "auto" }} lg={5}>
                  <Link to="/Login">
                    <ButtonVoltar />
                  </Link>
                  <Box
                    sx={{
                      mx: 4,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Titulo
                      sx={{ mb: 2 }}
                      align="left"
                      label="Esqueceu sua senha?"
                    ></Titulo>
                    <Subtitulo
                      label="Basta inserir o e-mail cadastrado em sua conta e
                    enviaremos um link para que você possa redefinir a sua
                    senha."
                    ></Subtitulo>

                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit}
                      sx={{ mt: 1 }}
                    >
                      <CampoEmail
                        value={email}
                        handlerChange={handlerChangeEmail}
                        label="Insira seu e-mail"
                        name="email"
                        disabled={loading}
                      />


                      <Box sx={{mt:2}}>
                      <ButtonAcaoGrande
                        loading={loading}
                        type="submit"
                        texto="Solicitar redefinição de senha"
                      />
                      </Box>
                      
                      
                    </Box>
                  </Box>
                </Grid>
              </Grid>

           
            </>
          )}
        </EspacoConteudoLateralDireito>
      </Grid >
    </>
  );
}
